export const Columns = [
    // {
    //     Header:'Id',
    //     accessor:'id'
    // },

    {
        Header:'Incident Name',
        accessor:'incident'
    },

    {
        Header:'Edit',
        // accessor:'last_name'
        id:"edit"

    },

    {
        Header:'Delete',
       id:"delete"

    },

]
